import { render, staticRenderFns } from "./search-jigou.vue?vue&type=template&id=23af907b&scoped=true&"
import script from "./search-jigou.vue?vue&type=script&lang=ts&"
export * from "./search-jigou.vue?vue&type=script&lang=ts&"
import style0 from "./search-jigou.vue?vue&type=style&index=0&id=23af907b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af907b",
  null
  
)

export default component.exports